import { render } from "./TemplateWorkbooksGrid.vue?vue&type=template&id=5bfc215a&scoped=true&ts=true"
import script from "./TemplateWorkbooksGrid.vue?vue&type=script&lang=ts"
export * from "./TemplateWorkbooksGrid.vue?vue&type=script&lang=ts"

import "./TemplateWorkbooksGrid.vue?vue&type=style&index=0&id=5bfc215a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfc215a"]])

export default __exports__